import { render, staticRenderFns } from "./TableAmberAsset.vue?vue&type=template&id=26700dd0&scoped=true"
import script from "./TableAmberAsset.vue?vue&type=script&lang=js"
export * from "./TableAmberAsset.vue?vue&type=script&lang=js"
import style0 from "./TableAmberAsset.vue?vue&type=style&index=0&id=26700dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26700dd0",
  null
  
)

export default component.exports